import React, { useContext, useState, useCallback, useEffect, useRef } from "react";
import { Form, Input, Select, Radio, Button, Space, Switch, Upload, Checkbox, Table, Card, Row, Col, DatePicker, InputNumber, Typography, Steps } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import { DashboardContext } from "context/DashboardContext";
import { ModalContext } from "context/ModalContext";
import { show_toast } from "utils/helpers";
import { api_srv } from "services";
import { create_client_direct_quoation, list_my_products, list_cover_types, FetchInsuranceClasses,list_undewriter_products, fetch_product_details } from "services/apiSrv";
import { useQuery } from "react-query";
import moment from "moment";
import Utils from "../../../../utils/data/utilities";
import { useMemo } from "react";
import { useQueryClient } from "react-query";
import select from "components/formFields/select";

const { TextArea } = Input;
const { Option } = Select;
const { Title } = Typography;


function ExcessRow({ options = [], onChange }) {
  const [selected, setSelected] = useState([]);

  const handleCheck = (option, isChecked) => {
    let updated;

    if (isChecked) {
      updated = [...selected, option];
    } else {
      updated = selected.filter((o) => o.label !== option.label);
    }

    setSelected(updated);
    onChange?.(updated);
  };

  if (!options.length) return null;

  return (
    <>
      {options.map((option, index) => {
        const checked = selected.some(
          (o) => o.label === option.label
        );

        return (
          <div
            key={index}
            className={`card mb-2 ${checked ? "border-primary" : ""}`}
          >
            <div className="card-body py-2">
              <div className="row align-items-center g-3">

                {/* Checkbox */}
                <div className="col-auto">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={checked}
                    onChange={(e) =>
                      handleCheck(option, e.target.checked)
                    }
                  />
                </div>

                {/* Label */}
                <div className="col">
                  <strong>{option.label}</strong>
                </div>

                {/* Value */}
                <div className="col">
                  <span className="text-muted">
                    {(option.value * 100).toFixed(2)}%
                  </span>
                </div>

              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}



export default function CreateDirectQuotation({ onHide, fetchQuotations }) {
  const [form] = Form.useForm();
  const [benefits, setBenefits] = useState([]);
  const [selectedBenefits, setSelectedBenefits] = useState([]);
  const selectRef = useRef(null)
  const [editingBenefitId, setEditingBenefitId] = useState(null);
  const [originalBenefit, setOriginalBenefit] = useState(null);
  const { quotation, setQuotation } = useContext(DashboardContext);
  const { modalClose } = useContext(ModalContext);
  const [selectedMake, setSelectedMake] = useState(null);
  const [currentStep, setCurrentStep] = useState(0);
  const [selectedProduct, setSelectedProduct]= useState(null)
  const [coverTypeProducts, setCoverTypeProducts]= useState(null)
  const [selectedClass, setSelectedClass]= useState(null)
  const [coverTypes, setCoverTypes] = useState([])
  const queryClient = useQueryClient();

  // State to hold all form data
  const [formData, setFormData] = useState({});
  const utils = new Utils();
  const cars = utils.getCars();


  const [excesses, setExcesses] = useState([]);
  const [selectedExcesses, setSelectedExcesses] = useState([]); 

 let excessConfig;
  const { data: productData, isLoading, isSuccess, isError, error, refetch } = useQuery({
    queryKey: ['productDetails', selectedProduct?.productSystemRef],
    queryFn: () => fetch_product_details(selectedProduct?.productSystemRef),
    enabled: !!selectedProduct?.productSystemRef,
    retry: 2,
    staleTime: 5 * 60 * 1000,
    onSuccess: (data) => {
      console.log("data excesss===", data)
      excessConfig = data
    },
  });


  console.log("product data detail0s", productData?.data?.[0]?.productCover?.supportedPeriods)
  

  const updateExcess = useCallback((id, updates) => {
    setExcesses(prev => {
      const updated = prev.map(ex =>
        ex.id === id ? { ...ex, ...updates } : ex
      );

      return updated;
    });
  }, []);



    const excessColumns = [
      {
        title: "Select",
        width: 80,
        render: (_, record) => (
          <Checkbox
            checked={record.selected}
            // disabled={record.excessType === "MANDATORY"} // Mandatory = always selected & can't uncheck
            onChange={(e) => updateExcess(record.id, { selected: e.target.checked })}
          />
        ),
      },
      {
        title: "Name",
        dataIndex: "name",
        render: (text) => <span style={{ fontWeight: 500 }}>{text || "-"}</span>,
      },
      {
        title: "Description",
        dataIndex: "description",
        render: (text) => <span style={{ color: "#595959" }}>{text || "-"}</span>,
      },
      {
        title: "Value Type",
        width: 120,
        render: (_, record) => (
          <span>
            {record.excessValueType === "PERCENTAGE" ? "Percentage" : "Fixed Amount"}
          </span>
        ),
      },
      {
        title: "Value",
        width: 110,
        render: (_, record) => (
          <span style={{ fontWeight: 500 }}>
            {record.excessValueType === "PERCENTAGE"
              ? `${record.value}%`
              : `KES ${Number(record.value || 0).toLocaleString()}`}
          </span>
        ),
      },
      {
        title: "Based On",
        width: 140,
        render: (_, record) => {
          const labels = {
            SUM_INSURED: "Sum Insured",
            CLAIM_AMOUNT: "Claim Amount",
            FIXED: "Fixed Amount",
          };
          return <span>{labels[record.basedOn] || record.basedOn}</span>;
        },
      },
      {
        title: "Type",
        width: 100,
        render: (_, record) => (
          <span
            style={{
              color: record.excessType === "MANDATORY" ? "#d9363e" : "#1890ff",
              fontWeight: "500",
            }}
          >
            {record.excessType === "MANDATORY" ? "Mandatory" : "Optional"}
          </span>
        ),
      },
    ];

  // Fetch products
  const { data: productList, isLoading: isLoadingProducts, error: productError } = useQuery({
    queryKey: ['products'],
    queryFn: list_my_products,
  });

  // Fetch cover types
  console.log("ipc", productList)


  // Fetch subclasses


  const { data: subclasses = [], isLoading: isSubclasses, error: subclassError } = useQuery({
    queryKey:["classes"],
    queryFn:FetchInsuranceClasses
  });
   


   const selectClass = useMemo(() => {
    console.log("sira", selectedProduct?.ira_code)
        console.log("sbc", subclasses?.data)
  if (!selectedProduct?.ira_code || !subclasses?.data) return null;
  return subclasses.data.find(cls => cls.ira_code === selectedProduct.ira_code);
}, [selectedProduct?.ira_code, subclasses?.data]);

const selectedClassSystemRef = selectClass?.ira_code;

    useEffect(() => {
      console.log("subclasses", subclasses)
      console.log("Selected Class:", selectClass);
      console.log("Class System Ref:", selectedClassSystemRef);
    }, [selectedClass, selectedClassSystemRef, selectedProduct?.ira_code]);

    const { 
      data: underwriterProductList, 
      isLoading: isProductUnderwriterLoading 
    } = useQuery({
      queryKey: ['underwriter_products', selectedClassSystemRef],
      queryFn: () => list_undewriter_products(selectedClassSystemRef),
      enabled: !!selectedClassSystemRef,
      retry: 1,
    });
    console.log("UPS", underwriterProductList)
  //filter subclasses based on selectedProduct.covertypes array
  //  subclasses
    //[] of ids


    const allAvailableProducts = useMemo(() => {
    const underwriterProducts = underwriterProductList?.data || [];
    const genericProducts = productList?.data?._value || [];
    

    return  [...underwriterProducts, ...genericProducts]
  }, [underwriterProductList, productList]);

  console.log("selected products", selectedProduct)
  const filteredByCoverTypes= allAvailableProducts.filter((product) =>product.covertypeSystemRef==formData.coverType)
  console.log("==filtered", formData)

  // Sync form data with state on step change
  useEffect(() => {
    form.setFieldsValue(formData);
  }, [currentStep, form, formData]);

  // Log API data for debugging
  useEffect(() => {
    console.log("productList:", productList);
    console.log("==formData==", formData)
    console.log("subclasses--:", subclasses);
    if (productError) console.error("Product fetch error:", productError);
    // if (coverTypeError) console.error("Cover type fetch error:", coverTypeError);
    if (subclassError) console.error("Subclass fetch error:", subclassError);
  }, [productList,  subclasses,formData, productError,  subclassError]);

  // Options for form fields
  const fieldOptions = {
    coverPeriod: [
      { value: "1", label: "1 Day" },
      { value: "7", label: "1 Week" },
      { value: "30", label: "1 Month" },
      { value: "90", label: "3 Months" },
      { value: "180", label: "6 Months" },
      { value: "360", label: "12 Months" },
    ],
    kycType: [
      { value: "INDIVIDUAL", label: "Individual" },
      { value: "CORPORATE", label: "Business" },
    ],
    benefitType: [
      { value: "optional", label: "Optional" },
      { value: "mandatory", label: "Mandatory" },
    ],
  };

  // Handle product selection to update benefits
  const handleProductChange = (productSystemRef) => {
  console.log("handlign product change")
  let selectedProduct = null;

  // intermediary products
  selectedProduct = productList?.data?._value?.find(
    (p) => p.productSystemRef === productSystemRef
  );

  // underwriter products
  if (!selectedProduct) {
    selectedProduct = underwriterProductList?.data?.find(
      (p) => p.productSystemRef === productSystemRef
    );
  }

  setSelectedProduct(selectedProduct);

  console.log("Selected Product (generic or underwriter):", selectedProduct);
    console.log("selected benefits", selectedProduct?.productBenefits)
    if (selectedProduct && selectedProduct.productBenefits.length > 0) {
      const formattedBenefits = selectedProduct.productBenefits.map(benefit => ({
        id: benefit.benefitSystemRef || `${Date.now()}-${Math.random()}`,
        benefitSystemRef: benefit.benefitSystemRef,
        selected: false,
        name: benefit.benefit_category_name || "Unnamed Benefit",
        description: `Covers ${benefit.benefitCalculationtype} with value ${benefit.benefitCalculationValue}`,
        type: benefit.benefitType || "optional",
        limit: benefit.benefitLimit?.defaultLimit || 0,
        adjustBenefit: benefit.benefitLimit?.isAdjustable || false,
        originalBenefit: { ...benefit },
      }));
      setBenefits(formattedBenefits);
      setSelectedBenefits([]);
      console.log("Benefits after product change:", formattedBenefits);
    } else {
      setBenefits([]);
      setSelectedBenefits([]);
      show_toast("No benefits available for this product", "warning");
    }


     if (selectedProduct && selectedProduct.productExcess) {
      const formattedExcesses = selectedProduct.productExcess
        setExcesses(formattedExcesses);
     } else {
      setExcesses([]);
      setSelectedExcesses([]);
     }
  };

  // Handle make selection
  const handleMakeChange = (value) => {
    setSelectedMake(value);
    form.setFieldsValue({ model: undefined });
  };

  // Get models for selected make
  const getModelsForMake = (make) => {
    const car = cars.find(car => car.brand === make);
    return car ? car.models.map(model => ({ value: model, label: model })) : [];
  };

  // Update benefit in state and sync selectedBenefits
  const updateBenefit = (id, updates) => {
    setBenefits(prevBenefits => {
      const updatedBenefits = prevBenefits.map(b =>
        b.id === id ? { ...b, ...updates } : b
      );
      if (updates.selected !== undefined) {
        const newSelectedBenefits = updatedBenefits
          .filter(b => b.selected)
          .map(b => ({
            ...b.originalBenefit,
            benefitInternaleRef: b.name,
            benefitType: b.type,
            benefitLimit: { ...b.originalBenefit.benefitLimit, defaultLimit: b.limit },
          }));
        setSelectedBenefits(newSelectedBenefits);
        console.log("Updated selectedBenefits:", newSelectedBenefits);
      }
      return updatedBenefits;
    });
  };

  // Handle edit button click
  const handleEdit = (benefit) => {
    setOriginalBenefit({ ...benefit });
    setEditingBenefitId(benefit.id);
  };

  // Handle cancel button during editing
  const handleCancel = () => {
    updateBenefit(editingBenefitId, originalBenefit);
    setEditingBenefitId(null);
    setOriginalBenefit(null);
  };

  // Handle save button during editing
  const handleSave = () => {
    setEditingBenefitId(null);
    setOriginalBenefit(null);
  };

  // Handle delete benefit
  const handleDelete = (id) => {
    setBenefits(prevBenefits => {
      const updatedBenefits = prevBenefits.filter(b => b.id !== id);
      const newSelectedBenefits = updatedBenefits
        .filter(b => b.selected)
        .map(b => ({
          ...b.originalBenefit,
          benefitInternaleRef: b.name,
          benefitType: b.type,
          benefitLimit: { ...b.originalBenefit.benefitLimit, defaultLimit: b.limit },
        }));
      setSelectedBenefits(newSelectedBenefits);
      return updatedBenefits;
    });
  };

  // Benefits table columns
  const benefitsColumns = [
    {
      title: "Select",
      render: (benefit) => (
        <Checkbox
          checked={benefit.selected}
          onChange={(e) => {
            console.log("Checkbox changed for benefit:", benefit.id, e.target.checked);
            updateBenefit(benefit.id, { selected: e.target.checked });
          }}
        />
      ),
    },
    {
      title: "Name",
      render: (benefit) => (
        editingBenefitId === benefit.id ? (
          <Input
            value={benefit.name}
            onChange={(e) => updateBenefit(benefit.id, {
              name: e.target.value,
              originalBenefit: { ...benefit.originalBenefit, benefitInternaleRef: e.target.value }
            })}
          />
        ) : (
          benefit.name
        )
      ),
    },
    {
      title: "Description",
      render: (benefit) => (
        editingBenefitId === benefit.id ? (
          <TextArea
            value={benefit.description}
            onChange={(e) => updateBenefit(benefit.id, { description: e.target.value })}
            rows={2}
          />
        ) : (
          benefit.description
        )
      ),
    },
    {
      title: "Type",
      render: (benefit) => (
        editingBenefitId === benefit.id ? (
          <Select
            value={benefit.type}
            onChange={(value) => updateBenefit(benefit.id, {
              type: value,
              originalBenefit: { ...benefit.originalBenefit, benefitType: value }
            })}
            style={{ width: '100%' }}
          >
            {fieldOptions.benefitType.map(option => (
              <Option key={option.value} value={option.value}>{option.label}</Option>
            ))}
          </Select>
        ) : (
          benefit.type
        )
      ),
    },
    {
      title: "Limit",
      render: (benefit) => (
        editingBenefitId === benefit.id ? (
          <InputNumber
            value={benefit.limit}
            onChange={(value) => updateBenefit(benefit.id, {
              limit: value,
              originalBenefit: { ...benefit.originalBenefit, benefitLimit: { ...benefit.originalBenefit.benefitLimit, defaultLimit: value } }
            })}
            min={0}
          />
        ) : (
          benefit.limit.toLocaleString()
        )
      ),
    },
    {
      title: "Adjust Benefit",
      render: (benefit) => (
        editingBenefitId === benefit.id ? (
          <Switch
            checked={benefit.adjustBenefit}
            onChange={(checked) => updateBenefit(benefit.id, {
              adjustBenefit: checked,
              originalBenefit: { ...benefit.originalBenefit, benefitLimit: { ...benefit.originalBenefit.benefitLimit, isAdjustable: checked } }
            })}
          />
        ) : (
          benefit.adjustBenefit ? 'Yes' : 'No'
        )
      ),
    },
    {
      title: "Action",
      render: (benefit) => (
        <Space>
          {editingBenefitId === benefit.id ? (
            <>
              <Button type="primary" size="small" onClick={handleSave}>Save</Button>
              <Button size="small" onClick={handleCancel}>Cancel</Button>
            </>
          ) : (
            <>
              <Button size="small" onClick={() => handleEdit(benefit)}>Edit</Button>
              <Button size="small" danger onClick={() => handleDelete(benefit.id)}>Delete</Button>
            </>
          )}
        </Space>
      ),
    },
  ];

  // Final form submission handler, uses formData state
  // ... (all your imports and state hooks) ...
  const lastStepValues = form.getFieldsValue();
  const finalFormData = {  ...lastStepValues };

  // const selectedProduct = subclasses?.data.find(
  //   (cls) => cls.ira_code === lastStepValues.insuranceClass
  // );
  
  // let coverTypes = [];
  const handleSelectChange = (value) => {
    console.log("VVVALUE", value)
    // value = selected option's "value" prop (ira_code)
    // const selectedProduct = subclasses?.data?.find(
    //   (cls) => cls.insurance_class_system_ref === value
    // );
     const pickedClass = subclasses?.data?.find(sub => sub?.insurance_class_system_ref === value);
     const pickedCoverTypes =   pickedClass?.insurancecovertypes || [];
     setCoverTypes(pickedCoverTypes)
  

    const selectedProduct = value.insurancecovertypes
    // const selectedClass = subclasses?.data
    console.log("SelectedPro", selectedProduct)

  // setSelectedClass()
  setSelectedProduct(selectedProduct)
  };

function handleSelectCoverChange(value){
  const availableProducts= allAvailableProducts.filter((product)=>product.covertypeSystemRef === value)

  setCoverTypeProducts(availableProducts)

}

const handleSubmit = useCallback(
  async () => {
    // Manually save the final step's data to formData before proceeding.
    // This is important because `handleNext` isn't called on the last step.
    const lastStepValues = form.getFieldsValue();
    const finalFormData = { ...formData, ...lastStepValues };

    console.log("Form values on submit:", finalFormData);

    // Manual check for benefits selection
    // if (selectedBenefits.length === 0) {
    //   show_toast("At least one benefit must be selected", "error");
    //   return;
    // }

    setQuotation((prev) => ({ ...prev, loading: true }));
    try {
      const payload = { ...finalFormData, selectedBenefits };

      if (payload.coverStartDate) {
        payload.coverStartDate = payload.coverStartDate.format("YYYY-MM-DD");
      }
      if (payload.driversLicenceUpload && payload.driversLicenceUpload.fileList?.length > 0) {
        payload.driversLicenceUpload = payload.driversLicenceUpload.fileList[0].originFileObj;
      }

      console.log("Submission payload:", payload);
      const res = await create_client_direct_quoation({ ...payload, excesses });
      console.log("API response:", res);
      queryClient.invalidateQueries(['clientQuotations']);
      fetchQuotations();
      modalClose();
      onHide?.();
      show_toast("Quotation created successfully", "success");
      form.resetFields();
      setBenefits([]);
      setSelectedBenefits([]);
      setCurrentStep(0); // Reset to the first step
      setFormData({}); // Reset form data state
    } catch (err) {
      console.error("Error creating quotation:", err.message, err.stack);
      show_toast(`Failed to create quotation: ${err.message}`, "error");
    } finally {
      setQuotation((prev) => ({ ...prev, loading: false }));
    }
  },
  [fetchQuotations, modalClose, selectedBenefits, onHide, formData, form]
);

  // Custom Next button handler with validation and data update
  const handleNext = async () => {
    try {
      let fieldsToValidate = [];
      if (currentStep === 0) {
        fieldsToValidate = ["insuranceClass", "coverType", "product", "internalRef", "coverStartDate", "coverPeriod", "description"];
      } else if (currentStep === 1) {
        // if (selectedBenefits.length === 0) {
        //   show_toast("At least one benefit must be selected", "error");
        //   return;
        // }
      } else if (currentStep === 2) {
        fieldsToValidate = ["firstName", "lastName", "email", "kraPin", "kycType", "driversLicenceUpload"];
      }

      await form.validateFields(fieldsToValidate);

      // Manually save the valid fields to the formData state
      const currentStepValues = form.getFieldsValue();
      setFormData(prevData => ({ ...prevData, ...currentStepValues }));

      // If validation passes, move to the next step
      setCurrentStep(currentStep + 1);
    } catch (err) {
      console.error("Validation failed:", err);
      show_toast("Please fill all required fields correctly to proceed.", "error");
    }
  };

 

  return (
    <div style={{ padding: '0px', background: '#f8fafc', minHeight: '#100vh' }}>
      <Card
        // title={<Title level={4}>Create Direct Quotation </Title>}
        style={{ borderRadius: '12px' }}
      >
        <Steps current={currentStep} style={{ marginBottom: '24px' }}>
          <Steps.Step title="Policy Details" />
          <Steps.Step title="Benefits" />
          <Steps.Step title="Excesses" />
          <Steps.Step title="Client Details" />
          <Steps.Step title="Risk Details" />

        </Steps>

        <Form
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
        >
          {/* STEP 1: Policy Details */}
          {currentStep === 0 && (
            <Card style={{ marginBottom: '24px', borderRadius: '8px' }}>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="insuranceClass"
                    label="Insurance Class"
                    rules={[{ required: true, message: 'Please select insurance class' }]}
                  >
                    <Select
                      placeholder="Select insurance class"
                      size="large"
                      ref={selectRef}
                     onChange={handleSelectChange}
                     defaultValue={lastStepValues?.insuranceClass}
                      disabled={isSubclasses || !subclasses?.data?.length}
                    >
                      {subclasses?.data?.length > 0 ? (
                        subclasses.data.map(option => (
                          <Option key={option.insurance_class_system_ref} value={option.insurance_class_system_ref}>{option.name}</Option>
                        ))
                      ) : (
                        <Option value="" disabled>No insurance classes available</Option>
                      )}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="coverType"
                    label="Cover Type"
                    rules={[{ required: true, message: 'Please select cover type' }]}
                  >
                    <Select
                      placeholder="Select cover type"
                      size="large"
                      onChange={handleSelectCoverChange}
                      
                    >
                      {coverTypes?.length > 0 ? (
                        coverTypes?.map(option => (
                          <Select.Option key={option.system_covertype_ref} label={option.name} value={option.system_covertype_ref}>{option.name}</Select.Option>
                        ))
                      ) : (
                        <Select.Option value="" disabled>No covertypes available</Select.Option>
                      )}

                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="product"
                    label="Product"
                    rules={[{ required: true, message: 'Please select product' }]}
                  >
                    <Select
                      placeholder="Select product"
                      size="large"
                      onChange={handleProductChange}
                      // loading={isLoadingProducts}
                      // labelInValue={true}
                      // disabled={productList?.data?.length > 0}
                    >
                      {allAvailableProducts?.length > 0 ? (
                        coverTypeProducts?.map((option, i) => (
                          <Option key={i} value={option.productSystemRef} label={option.productName}>
                            {option.productName}
                          </Option>
                        ))
                      ) : (
                        <Option value="" disabled>No products available</Option>
                      )}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="internalRef"
                    label="Internal Reference"
                    rules={[{ required: true, message: 'Please input internal reference' }]}
                  >
                    <Input placeholder="Enter internal reference" size="large" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="coverStartDate"
                    label="Cover Start Date"
                    rules={[{ required: true, message: 'Please select cover start date' }]}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      size="large"
                      disabledDate={(current) => current && current < moment().startOf('day')}
                      showToday={true}
                      placeholder="Select start date"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="coverPeriod"
                    label="Cover Period"
                    rules={[{ required: true, message: 'Please select cover period' }]}
                  >
                    <Select placeholder="Select cover period" size="large">
                      {productData?.data?.[0]?.productCover?.supportedPeriods && productData?.data?.[0]?.productCover?.supportedPeriods.map((option,index) => (
                        <Option key={index} value={option}>{option}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item
                    name="description"
                    label="Description"
                    rules={[{ required: true, message: 'Please input description' }]}
                  >
                    <TextArea placeholder="Enter description" rows={4} size="large" />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          )}

          {/* STEP 2: Benefits */}
          {currentStep === 1 && (
            <Card style={{ marginBottom: '24px', borderRadius: '8px' }}>
              {benefits.length > 0 ? (
                <Table
                  dataSource={benefits}
                  columns={benefitsColumns}
                  rowKey="id"
                  pagination={{ pageSize: 5 }}
                  rowClassName={(benefit) => benefit.selected ? 'ant-table-row-selected' : ''}
                />
              ) : (
                <Typography.Text type="secondary">No benefits available. Please select a product in the previous step.</Typography.Text>
              )}
            </Card>
          )}

          {/* STEP 3: Excesses */}
          {currentStep === 2 && productData?.data?.[0]?.excessConfig?.options && (
            <Card style={{ marginBottom: '24px', borderRadius: '8px' }}>
              <Title level={5}>Policy Excesses</Title>
              {productData?.data?.[0]?.excessConfig.options && (<ExcessRow options={productData?.data?.[0]?.excessConfig.options}/>)}
            </Card>
            )}
          {/* STEP 4: Client Details */}
          {currentStep === 3 && (
            <Card style={{ marginBottom: '24px', borderRadius: '8px' }}>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="firstName"
                    label="First Name"
                    rules={[{ required: true, message: 'Please input first name' }]}
                  >
                    <Input placeholder="Enter first name" size="large" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="lastName"
                    label="Last Name"
                    rules={[{ required: true, message: 'Please input last name' }]}
                  >
                    <Input placeholder="Enter last name" size="large" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                      { required: true, message: 'Please input email' },
                      { type: 'email', message: 'Please enter a valid email' }
                    ]}
                  >
                    <Input placeholder="Enter email" size="large" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="phone"
                    label="Phone Number"
                    rules={[
                      { required: true, message: 'Please input phone number' },
                      { pattern: /^254[0-9]{9}$/, message: 'Please enter a valid Kenyan phone number (e.g. 254725596227)' }
                    ]}
                  >
                    <Input
                      placeholder="e.g. 254725596227"
                      size="large"
                      maxLength={12}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="kraPin"
                    label="KRA PIN"
                    rules={[{ required: true, message: 'Please input KRA PIN' }]}
                  >
                    <Input placeholder="Enter KRA PIN" size="large" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="kycType"
                    label="Client Type"
                    rules={[{ required: true, message: 'Please select client type' }]}
                  >
                    <Radio.Group options={fieldOptions.kycType} size="large"  />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="driversLicenceUpload"
                    label="Driver's License Upload"
                    rules={[{ required: true, validator: (_, value) => value?.fileList?.length > 0 ? Promise.resolve() : Promise.reject("Please upload driver's license") }]}
                  >
                    <Upload name="driversLicenceUpload" beforeUpload={() => false} maxCount={1}>
                      <Button icon={<UploadOutlined />} size="large">Upload License</Button>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          )}

          {/* STEP 5: Risk Details */}
          {currentStep === 4 && (
            <Card style={{ marginBottom: '24px', borderRadius: '8px' }}>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="make"
                    label="Make"
                    rules={[{ required: true, message: 'Please select make' }]}
                  >
                    <Select
                      placeholder="Select make"
                      size="large"
                      onChange={handleMakeChange}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {cars.map(car => (
                        <Option key={car.brand} value={car.brand}>{car.brand}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="model"
                    label="Model"
                    rules={[{ required: true, message: 'Please select model' }]}
                  >
                    <Select
                      placeholder={selectedMake ? "Select model" : "Select a make first"}
                      size="large"
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      disabled={!selectedMake}
                    >
                      {getModelsForMake(selectedMake).length > 0 ? (
                        getModelsForMake(selectedMake).map(option => (
                          <Option key={option.value} value={option.value}>{option.label}</Option>
                        ))
                      ) : (
                        <Option value="" disabled>No models available</Option>
                      )}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="value"
                    label="Value"
                    rules={[
                      { required: true, message: 'Please input value' },
                      { validator: (_, value) => value > 0 ? Promise.resolve() : Promise.reject('Value must be positive') }
                    ]}
                  >
                    <InputNumber placeholder="Enter value" min={0} style={{ width: '100%' }} size="large" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="regNo"
                    label="Registration Number"
                    rules={[{ required: true, message: 'Please input registration number' }]}
                  >
                    <Input placeholder="Enter registration number" size="large" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="year"
                    label="Year of Manufacture"
                    rules={[
                      { required: true, message: 'Please input year of manufacture' },
                      { validator: (_, value) => value > 0 && Number.isInteger(value) ? Promise.resolve() : Promise.reject('Year of manufacture must be a positive integer') }
                    ]}
                  >
                    <InputNumber placeholder="Enter year" min={1900} max={new Date().getFullYear() + 1} style={{ width: '100%' }} size="large" />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          )}

          {/* Form Actions */}
          <Form.Item style={{ textAlign: 'right' }}>
            <Space direction="horizontal" size="middle">
              {currentStep > 0 && (
                <Button size="large" onClick={() => setCurrentStep(currentStep - 1)}>
                  Back
                </Button>
              )}
 
              {currentStep < 4 && (
                <Button type="primary" size="large" onClick={handleNext}>
                  Next
                </Button>
              )}
              {currentStep === 4 && (
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={quotation?.loading}
                  size="large"
                >
                  Create Quotation
                </Button>
              )}

              <Button
                size="large"
                onClick={() => {
                  modalClose();
                  onHide?.();
                }}
                style={{ minWidth: '120px' }}
              >
                Cancel
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}